module.exports = "/assets/cb8460a6c9dfbe05dc0e2404e5cd72a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZH.png
// module id = 2064
// module chunks = 0